export const resetCustoms = (setUSposition, setUSpositionData, USpositionInit, USpositionDataInit) => {
  setUSposition((prev) => ({
    ...prev,
    generaldutyimp: USpositionInit.generaldutyimp,
    additionaldutyimp: USpositionInit.additionaldutyimp,
    harborfeepct: USpositionInit.harborfeepct,
    merchprocfeepct: USpositionInit.merchprocfeepct,
    flatfee: USpositionInit.flatfee,
    tsca: USpositionInit.tsca,
    isf: USpositionInit.isf,
  }));
  setUSpositionData((prev) => ({
    ...prev,
    generaldutyimp: USpositionDataInit.generaldutyimp,
    additionaldutyimp: USpositionDataInit.additionaldutyimp,
    harborfeepct: USpositionDataInit.harborfeepct,
    merchprocfeepct: USpositionDataInit.merchprocfeepct,
    flatfee: USpositionDataInit.flatfee,
    tsca: USpositionDataInit.tsca,
    isf: USpositionDataInit.isf,
  }));
};

export const resetInbound = (setUSposition, setUSpositionData, USpositionInit, USpositionDataInit) => {
  setUSposition((prev) => ({
    ...prev,
    ["inpayload"]: USpositionInit.inpayload,
    ["indrayage"]: USpositionInit.indrayage,
    ["unloading"]: USpositionInit.unloading,
    ["incollectcharges"]: USpositionInit.incollectcharges,
    ["inboundothers"]: USpositionInit.inboundothers,
  }));
  setUSpositionData((prev) => ({
    ...prev,
    ["inpayload"]: USpositionDataInit.inpayload,
    ["indrayage"]: USpositionDataInit.indrayage,
    ["unloading"]: USpositionDataInit.unloading,
    ["incollectcharges"]: USpositionDataInit.incollectcharges,
    ["inboundothers"]: USpositionDataInit.inboundothers,
  }));
};

export const resetOutbound = (
  USposition,
  USpositionData,
  setUSposition,
  setUSpositionData,
  USpositionInit,
  USpositionDataInit,
  positionEdits,
  editID,
  setEditID
) => {
  const fieldnames = ["outdrayage", "loading", "outcollectcharges", "outboundothers", "outpayload"];
  const figuretypes = ["currency", "currency", "currency", "currency"];
  fieldnames.forEach((field, i) => {
    positionEdits.current.push({
      editID: editID,
      name: field,
      value: USposition[field],
      num: USpositionData[field],
      figuretype: figuretypes[i],
    });
    setEditID((prev) => prev + 1);
  });

  console.log(positionEdits.current);

  setUSposition((prev) => ({
    ...prev,
    ["outpayload"]: USpositionInit.outpayload,
    ["outdrayage"]: USpositionInit.outdrayage,
    ["loading"]: USpositionInit.loading,
    ["outcollectcharges"]: USpositionInit.outcollectcharges,
    ["outboundothers"]: USpositionInit.outboundothers,
  }));
  setUSpositionData((prev) => ({
    ...prev,
    ["outpayload"]: USpositionDataInit.outpayload,
    ["outdrayage"]: USpositionDataInit.outdrayage,
    ["loading"]: USpositionDataInit.loading,
    ["outcollectcharges"]: USpositionDataInit.outcollectcharges,
    ["outboundothers"]: USpositionDataInit.outboundothers,
  }));
};

export const resetOceanfreight = (setUSposition, setUSpositionData, USpositionInit, USpositionDataInit) => {
  setUSposition((prev) => ({
    ...prev,
    ["oceanpayload"]: USpositionInit.oceanpayload,
    ["oceanfreight"]: USpositionInit.oceanfreight,
  }));
  setUSpositionData((prev) => ({
    ...prev,
    ["oceanpayload"]: USpositionDataInit.oceanpayload,
    ["oceanfreight"]: USpositionDataInit.oceanfreight,
  }));
};
